<ion-header class="ion-no-border page menu-page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div class="leada-powered">POWERED BY LEADA AG</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="goBack()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-padding page" no-bounce>
  <div #line class="line" [style.top]="lineY"></div>
  <ion-list lines="none" class="menu">
    <ion-item button disabled><div translate>MENU.TODAY.NAME</div></ion-item>
    <ion-item button (click)="showDialogsPage()"><div translate>MENU.TODAY.DIALOGS<ion-badge *ngIf="newDialogsCount" button-end class="badge">{{ newDialogsCount }}</ion-badge></div></ion-item>
    <!--ion-item button (click)="showReflectionsPage(0)"><div translate>MENU.TODAY.REFLECTIONS</div></ion-item> 
    <ion-item button class="second-level" (click)="showReflectionsPage(1)"><div translate>MENU.TODAY.MINDSET</div></ion-item> 
    <ion-item button class="second-level" (click)="showReflectionsPage(2)"><div translate>MENU.TODAY.EFFICACY</div></ion-item> 
    <ion-item button class="second-level" (click)="showReflectionsPage(3)"><div translate>MENU.TODAY.PERFORMANCE</div></ion-item> 
    <ion-item button class="second-level" (click)="showReflectionsPage(4)"><div translate>MENU.TODAY.MOOD</div></ion-item--> 
    <ion-item button (click)="showMessagesPage()" *ngIf="showMenuEntry('MENU.TODAY.MESSAGES')"><div translate>MENU.TODAY.MESSAGES</div></ion-item>
</ion-list>

</ion-content>

<ion-footer class="page">
  <ion-button fill="clear" shape="round" (click)="showSettings()" class="settings"><ion-icon slot="icon-only"></ion-icon></ion-button>
  <ion-button fill="clear" shape="round" (click)="showSearch()" class="search"><ion-icon slot="icon-only"></ion-icon></ion-button>
</ion-footer>